import React from "react";
import { Star } from "@otp/icons";
import { Chip, Typography, Delimiter } from "@otp/ui";

import { getAddress } from "src/utils/restaurant-data";
import { StoreModel } from "src/graphql/generated/graphql";
import { OtpBreakdownItem } from "./otp-breakdown-item";
import { ViewDetailsButton } from "./view-details-button";
import styles from "./item.module.css";

interface ListItemProps {
  store: Partial<StoreModel>;
  onClick?: () => void;
}

export const ListItem = ({ store, onClick }: ListItemProps) => {
  const { storeUsersCountByLevel, primaryOTPsCount } = store;

  return (
    <div className={styles.root} onClick={onClick}>
      <div className="flex justify-between">
        <Chip label={`#${store.nationalStoreNumber}`} className="-ml-1" />
        <ViewDetailsButton storeId={store.id} />
      </div>
      <Typography
        fontWeight="bold"
        variant="subtitle1"
        component="div"
        className="mt-1"
      >
        {store.name}
      </Typography>
      <Typography variant="subtitle2" component="div">
        {getAddress(store)}
      </Typography>
      <Delimiter className="mt-1.5" />
      <div className="mt-3 flex justify-between pr-8">
        <OtpBreakdownItem
          label="OTP3"
          count={storeUsersCountByLevel?.["otp-3"] || 0}
        />
        <OtpBreakdownItem
          label="OTP2"
          count={storeUsersCountByLevel?.["otp-2"] || 0}
        />
        <OtpBreakdownItem
          label="OTP1"
          count={storeUsersCountByLevel?.["otp-1"] || 0}
        />
        <OtpBreakdownItem
          label="OTP0"
          count={storeUsersCountByLevel?.["otp-0"] || 0}
        />
        <OtpBreakdownItem label={<Star />} count={primaryOTPsCount || 0} />
      </div>
    </div>
  );
};
